'use client';

import 'swiper/css';
import 'swiper/css/pagination';
import './slider.scss';

import { Slider } from '@generated-client/strapi';
import { ProductBanner } from '@trwl/entities/product/banner';
import { A11y, Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

export const ProductSliderBanner = ({ sliders }: { sliders: Slider[] }) => {
  return (
    <Swiper
      modules={[Pagination, A11y, Autoplay]}
      pagination={{ clickable: true }}
      loop={true}
      autoplay={{
        delay: 5000,
        disableOnInteraction: false,
      }}
      spaceBetween={0}
      slidesPerView={1}
      className="relative contaiter w-full mx-auto"
    >
      {sliders.map((item, index) => (
        <SwiperSlide key={index} className="slide">
          <ProductBanner
            priority={true}
            href={item.link}
            title={item.title}
            description={item.subtitle ?? ''}
            image={item.image?.data?.attributes?.url ?? ''}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
